import DataTable from './data-table';

export default DataTable;
